export default "__VITE_ASSET__CgHJI$ah__"